import React from 'react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  note?: string;
  dark?: boolean;
};
export function SectionCta({
  label,
  note = 'Instant access · One payment of $27 · All 6 volumes + 5 bonuses',
  dark = false
}: SectionCtaProps) {
  return <div className="mt-12 px-1" data-id="element-313" data-mp="3nc9rxynuhq4m">
      <CtaButton label={label} size="md" data-id="element-314" data-mp="3nbguxpeouezo" />
      <p className={`mt-4 text-center text-sm ${dark ? 'text-white/60' : 'text-ink/60'}`} data-id="element-315" data-mp="3nemg4tk74wq4">{note}</p>
    </div>;
}